<rt-assistant-list-card [linkTarget]="linkTarget()" [label]="interval()">
  <div class="rows">
    <span class="when">{{ interval() }}</span>
    @if (data().candidate; as candidate) {
      <rt-list-row-person
        avatarSize="small-x"
        [data]="{
          name: candidate.name,
          avatarUrl: candidate.avatarUrl,
          initials: candidate.initials,
        }"
      />
    }
    @if (data().assignedJob; as job) {
      <span class="job-ref">
        <span [class]="['status-dot', 'status-dot--' + job.status]"></span>
        <span class="job-title">{{ job.title }}</span>
      </span>
    }
  </div>
</rt-assistant-list-card>
